import axiosInstance from "./axiosInstance";
import APIEndpoint from "./endpoint";

export const getProfile = async () => {
  const url = `${APIEndpoint.GET_PROFILE_API}`;

  const res = await axiosInstance.get(url);
  //console.log(res);
  return res;
};

export const changePassword = async (request) => {
  const url = `${APIEndpoint.CHANGE_PASSWORD_API}`;

  const payload = {
    requestObject: {
      currentPassword: request.current_p,
      newPassword: request.new_p,
      confirmPassword: request.confirm_p,
    },
  };

  const res = await axiosInstance.post(url, JSON.stringify(payload));
  return res;
};

export const updateProfile = async (request) => {
  const url = `${APIEndpoint.PUT_PROFILE_API}`;
  const payload = {
    requestObject: {
      userId: request.userId,
      username: request.username,
      firstname: request.firstname,
      lastname: request.lastname,
      roleId: request.roleId,
      email: request.email,
      description: request?.description,
      accountStatus: request?.accountStatus,
      accountUserType: request?.accountUserType,
      estateId: request.estateId,
      lineOfWorkId: request.lineOfWorkId,
      fromPage: request?.fromPage,
    },
  };

  const res = await axiosInstance.put(url, JSON.stringify(payload));
  return res;
};

export const resendEmail = async (email) => {
  const url = `${APIEndpoint.RESEND_EMAIL_USER_API}?email=${email}`;
  const res = await axiosInstance.get(url);
  return res;
};
